import './index.less';
import { SvgIcon, NavAnchor, Select } from '@/components';
import { User,  apiService } from '@/shared';
import Tooltip from 'rc-tooltip';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ArgtModal from '@/pages/Home/AgrtModal';
import i18n from '@/i18n/react-i18next-config';
import Cookies from 'js-cookie';
import { baseUrl } from '@/shared/utils';

const defaultAvatarImg =
  'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png';

interface HeaderProps {
  user: User;
}

export function Header() {
  const { protocol, host, href } = window.location;
  let lang = localStorage.getItem('language');
  if (!lang) {
    localStorage.setItem('language', 'cn');
    lang = 'cn';
  }
  const isLogin = sessionStorage.getItem('login') === '0' ? false : true;
  const [language, setLanguage] = useState(lang);
  const [user, setUser] = useState<User>();
  const userInfo = {
    developerId: 111,
    nickname: '',
    developerName: '',
    developerType: 2,
    mid: 1553687,
    avatar:
      'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
  };

  const history = useHistory();
  const changeLanguage = (key: string) => {
    const value = key;
    setLanguage(value);
    localStorage.setItem('language', value);
    i18n.changeLanguage(value);
  };

  const handleLogout = () => {
    Cookies.set('devglobal_slh', '');
    Cookies.set('userId', '');
    Cookies.set('serviceToken', '');
    history.push('/');
    window.location.reload();
    sessionStorage.setItem('login', '0');
  };

  const goLogin = () => {
    window.open(
      `${baseUrl}/login?platform=widget&redirectUrl=${encodeURIComponent(
        href,
      )}`
    );
  }

  const loadUser = async () => {
    try {
      const data = await apiService.getCurrentUser();
      if(!data) {
        setUser(userInfo)
      }else {
        setUser(data);
      }
      ArgtModal.show();
    } catch (e) {
      console.error('get user failed', e);
      // if (e instanceof ApiBizError && e.code === 1009) {
      //   // 非开发者则跳转小米开放平台开发者类型选择页面
      //   window.location.href =
      //     'https://dev.mi.com/distribute/developer/select-bind-type';
      // }
    }
  };

  useEffect(() => {
    loadUser();
  }, []);


  return (
    <header className="main-content-wrapper mag-header-wrapper">
      <div className="mag-header">
        <div className="mag-logo cursor" onClick={() => history.push('/')}>
          <SvgIcon name="logo" />
          <span>{window.trans('widget')}</span>
        </div>
        <NavAnchor />
        { isLogin ? <Tooltip
          placement="bottom"
          overlay={
            <ul className="mag-header__dropdown">
              <li onClick={handleLogout}>
                { window.trans('logout')}
              </li>
            </ul>
          }
        >
          <div className="mag-user">
            <img alt="" src={user?.avatar || defaultAvatarImg} />
            <div>
              <span>{user?.nickname}</span>
              <span>{user?.mid}</span>
            </div>
          </div>
        </Tooltip> :
        <div className="mag-user unLogin" onClick={goLogin}>
          <img alt="" src={user?.avatar || defaultAvatarImg} />
          <span>{window.trans('sign-in')}</span>
        </div>}
        <div>
          <Select
            className="choice-lan-select"
            customContent={
              <div className="mag-language cursor">
                <SvgIcon name="ground" />
                {/* <img src={user?.avatar} className="add-div"></img> */}
              </div>
            }
            selectedKeys={[language]}
            onChange={(value, key: string) => changeLanguage(key)}
            options={[
              { key: 'cn', value: '中文' },
              { key: 'en', value: 'English' },
            ]}
          ></Select>
        </div>
      </div>
    </header>
  );
}
